import { Box, useMediaQuery } from '@mui/material'
import { Wallet } from './wallet'
import { Loader } from '../../shared/loader/loader'
import { useGetUser } from '../../hooks/useGetUser'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getWalletDirection } from '../../redux/actions/wallet.actions'
import { setWalletDirection } from '../../redux/reducers/wallets.reducer'

// TODO: IMPROVE LOADING STATE
export const WalletsContainer = () => {
  const {
    credentials,
    isLoadingCredentials,
    polygonAddress,
    tronAddress,
    isLoadingWalletDirection,
  } = useGetUser()

  const dispatch = useDispatch()

  const isDesktop = useMediaQuery('(min-width: 1024px)')

  useEffect(() => {
    if (credentials?.id) {
      dispatch(getWalletDirection(credentials?.id))
    } else {
      dispatch(
        setWalletDirection({
          polygonAddress: null,
          tronAddress: null,
          isLoading: false,
          error: null,
        })
      )
    }
  }, [dispatch, credentials?.id])

  if (isLoadingCredentials || isLoadingWalletDirection) return <Loader />

  if (!polygonAddress && !tronAddress) return

  return (
    <Box display="flex" gap={'24px'} flexWrap={'wrap'}>
      <Box
        display="flex"
        flexDirection="column"
        gap={'24px'}
        width={!isDesktop ? '100%' : '50%'}
      >
        <Wallet polygonAddress={polygonAddress} tronAddress={tronAddress} />
      </Box>
    </Box>
  )
}
